export const SupplierResponsesIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 10C14 10.3536 13.8595 10.6928 13.6095 10.9428C13.3594 11.1929 13.0203 11.3333 12.6667 11.3333H4.66667L2 14V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V10Z"
        stroke="#3F3F46"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6.66536L7.33333 7.9987L10 5.33203"
        stroke="#3F3F46"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TemplatesIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3335 4.66667V11.3333M4.00016 3.33333V12.6667M8.00016 2H13.3335C14.0699 2 14.6668 2.59695 14.6668 3.33333V12.6667C14.6668 13.403 14.0699 14 13.3335 14H8.00016C7.26378 14 6.66683 13.403 6.66683 12.6667V3.33333C6.66683 2.59695 7.26378 2 8.00016 2Z"
        stroke="#3F3F46"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NewSpecificationIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66667 14.6654H12C12.3536 14.6654 12.6928 14.5249 12.9428 14.2748C13.1929 14.0248 13.3333 13.6857 13.3333 13.332V4.66536L10 1.33203H4C3.64638 1.33203 3.30724 1.47251 3.05719 1.72256C2.80714 1.9726 2.66667 2.31174 2.66667 2.66536V5.33203M9.33333 1.33203V3.9987C9.33333 4.35232 9.47381 4.69146 9.72386 4.94151C9.97391 5.19156 10.313 5.33203 10.6667 5.33203H13.3333M2 9.9987H6M4 7.9987V11.9987"
        stroke="#3F3F46"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DashboardIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 3H3.66667C3.29848 3 3 3.29848 3 3.66667V8.33333C3 8.70152 3.29848 9 3.66667 9H7C7.36819 9 7.66667 8.70152 7.66667 8.33333V3.66667C7.66667 3.29848 7.36819 3 7 3Z"
        stroke="#3F3F46"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3333 3H11C10.6318 3 10.3333 3.29848 10.3333 3.66667V5.66667C10.3333 6.03486 10.6318 6.33333 11 6.33333H14.3333C14.7015 6.33333 15 6.03486 15 5.66667V3.66667C15 3.29848 14.7015 3 14.3333 3Z"
        stroke="#3F3F46"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3333 9H11C10.6318 9 10.3333 9.29848 10.3333 9.66667V14.3333C10.3333 14.7015 10.6318 15 11 15H14.3333C14.7015 15 15 14.7015 15 14.3333V9.66667C15 9.29848 14.7015 9 14.3333 9Z"
        stroke="#3F3F46"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11.6667H3.66667C3.29848 11.6667 3 11.9651 3 12.3333V14.3333C3 14.7015 3.29848 15 3.66667 15H7C7.36819 15 7.66667 14.7015 7.66667 14.3333V12.3333C7.66667 11.9651 7.36819 11.6667 7 11.6667Z"
        stroke="#3F3F46"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
